<!--
 * @Date: 2024-01-08 16:31:37
 * @Author: jm
 * @LastEditTime: 2024-05-30 16:38:46
 * @LastEditors: jm
 * @FilePath: \wxyze\src\components\CustomFooter.vue
 * @Description: 
-->

<template>
  <div class="footer">
    <div class="conBox">
      <p class="first">
        Email：wxyze@gmail.com
      </p>
      <p>Copyright © 2023 www.wxyze.com</p>
      <p>All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 10rem;
  background-color: #fff1f1;
  padding: 60px 0px;
  margin: 0 auto 200px;

  .conBox {
    width: 100%;
    background-color: #fff1f1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .first {
      margin-bottom: 20px;
    }
    p {
      font-size: 35px;
      font-weight: bold;
      color: #402943;
      line-height: 60px;
    }
  }
}
</style>
